import { $authHost } from ".."

export const getDepartmentsAllAPI = async ({ departmentTypeId }) => {

    let params = ''

    if (departmentTypeId) {
        params = `?departmentTypeId=${departmentTypeId}`
    }

    const {data} = await $authHost.get(`api/departments/all${params}`)
    return data
}

export const checkPersonInDepartmentAPI = async ({ departmentId, type }) => {
    const {data} = await $authHost.post(`api/departments/check_person_in_department`, { departmentId, type })
    return data
}